import { useGetEcSiteOrdersSystemTypes } from '@/hooks/features/ecSiteOrders'

export const useCheckSystemTypesForImportMaster = () => {
  const { isLoading, isSuccess } = useGetEcSiteOrdersSystemTypes({
    queryParams: {
      yahooType: 'separated',
    },
    config: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  })

  return {
    isStored: isSuccess,
    isLoading,
  }
}
